<template>
  <div :class="['jumbo', size]">
    <!-- Background -->
    <div class="jumbo__background">
      <slot name="background" />
    </div>

    <!-- Content -->
    <div :class="['jumbo__content', { spaced, reverseOnMobile }]">
      <!-- Before -->
      <div class="jumbo__content--before">
        <slot name="before" />
      </div>

      <!-- After -->
      <div class="jumbo__content--after">
        <slot name="after" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'lg',
    },

    spaced: {
      type: Boolean,
      default: false,
    },

    reverseOnMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="postcss">
.jumbo {
  @apply relative w-full overflow-hidden;

  &.sm {
    @apply lg:h-[16rem];
  }

  &.md {
    @apply lg:h-[24rem];
  }

  &.lg {
    @apply lg:h-[36rem];
  }

  &.full {
    @apply lg:h-full;
  }

  &.screen {
    @apply h-screen overflow-auto;
  }

  &__background {
    @apply absolute top-0 bottom-0 left-0 right-0 z-[1];
  }

  &__content {
    @apply relative w-full h-full flex flex-col lg:flex-row justify-around items-center p-sm gap-xxs z-[2];

    &.spaced {
      @apply p-xl lg:p-xxl gap-xs;
    }

    &.reverseOnMobile {
      @apply flex-col-reverse lg:flex-row;
    }

    &--before {
      @apply style-title-bold lg:style-headline-bold;
    }
  }
}
</style>
